define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.sort;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/sort.js
// module id = 333
// module chunks = 1